import styled from "styled-components";
import { InputLabel, TextField } from "@material-ui/core";

export const CustomTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #d92b3c !important;
      border-width: 1px !important;
    }
  }
  & .MuiInputBase-root {
    background: #fff;
  }
`;

export const PageContainer = styled.div`
  background-color: #ffffff;
  min-height: 100vh;
  color: #333333;
  font-family: "Inter", "Roboto", sans-serif;
`;

export const HeroSection = styled.div`
  background-color: #ffffff;
  padding: 2rem 2rem 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    padding: 1rem 1rem 0;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 900px) {
    padding: 1rem;
  }
`;

export const HeroTopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const StatsGrid = styled.div`
  display: flex;
  gap: 2rem;
  padding-top: 2rem;
  width: 100%;

  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    text-align: left;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const StatItem = styled.div`
  flex: 1;
`;

export const StatLabel = styled.div`
  font-size: 0.7rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;
`;

export const StatValue = styled.div`
  font-size: 0.9rem;
  color: #1A1A1A;

  span {
    color: #d92b3c;
    font-weight: bold;
    font-size: 1.3rem;
    font-family: 'Playfair Display', serif;
  }
`;

export const HeroText = styled.div`
  flex: 0 0 58%;
  max-width: 58%;
  padding-right: 4rem;

  @media (max-width: 900px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 0;
    margin-bottom: 3rem;
  }

  @media (max-width: 600px) {
    margin-bottom: 1.5rem;
  }
`;

export const HeroImageContainer = styled.div`
  flex: 0 0 38%;
  max-width: 38%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 900px) {
    flex: 0 0 100%;
    max-width: 100%;
    justify-content: center;
  }
`;

export const HeroImage = styled.img`
  max-width: 100%;
  width: 100%;
  height: 460px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  object-fit: cover;

  @media (max-width: 900px) {
    height: 350px;
  }

  @media (max-width: 600px) {
    height: 240px;
  }
`;

export const SubHeading = styled.p`
  color: #666;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    font-size: 0.65rem;
  }
`;

export const Title = styled.h1`
  font-family: 'Playfair Display', serif;
  font-size: 4.5rem;
  font-weight: 500;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  color: #1A1A1A;

  @media (max-width: 600px) {
    font-size: 2.2rem;
    margin-bottom: 1rem;
  }
`;

export const Description = styled.div`
  font-size: 1.15rem;
  line-height: 1.8;
  color: #555555;
  margin-bottom: 2.5rem;
  max-width: 95%;
  font-weight: 400;
  letter-spacing: -0.01em;

  @media (max-width: 600px) {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  
  @media (max-width: 900px) {
    justify-content: center;
    gap: 1rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    
    > button {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const PrimaryButton = styled.button`
  background: #d92b3c;
  color: white;
  border: none;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;

  &:hover {
    background: #C8322D;
  }

  @media (max-width: 600px) {
    padding: 0.5rem 0.8rem;
    font-size: 0.75rem;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: #d92b3c;
  border: 1px solid #d92b3c;
  padding: 0.65rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 1px;

  &:hover {
    background: #FFF0F2;
    border: 1px solid #d92b3c;
  }

  @media (max-width: 600px) {
    padding: 0.5rem 0.8rem;
    font-size: 0.75rem;
  }
`;

export const WizardSection = styled.div`
  background: #ffffff;
  padding: 1rem 2rem 4rem;
  display: flex;
  justify-content: center;

  @media (max-width: 600px) {
    padding: 2rem 1rem;
  }
`;

export const WizardContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.06);

  @media (max-width: 600px) {
    padding: 1.5rem;
  }
`;

export const WizardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    background: #e2e8f0;
    z-index: 0;
  }
`;

export const WizardStep = styled.div<{ active?: boolean; completed?: boolean }>`
  position: relative;
  z-index: 1;
  background: ${props => props.active || props.completed ? '#d92b3c' : '#e2e8f0'};
  color: ${props => props.active || props.completed ? 'white' : '#64748b'};
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: ${props => props.active ? '0 0 0 4px rgba(255, 0, 77, 0.2)' : 'none'};
  transition: all 0.3s;
`;

export const WizardStepLabel = styled.div<{ active?: boolean }>`
  position: absolute;
  top: 45px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.8rem;
  font-weight: ${props => props.active ? '700' : '500'};
  color: ${props => props.active ? '#1A1A1A' : '#64748b'};
  white-space: nowrap;
`;

export const StepContent = styled.div`
  min-height: 300px;
  animation: fadeIn 0.4s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const StepIndicatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.5rem;
  gap: 12px;
  
  @media (max-width: 768px) {
    overflow-x: auto;
    padding-bottom: 12px;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1; 
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d92b3c; 
      border-radius: 4px;
    }
  }
`;

export const StepIndicatorItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  
  @media (max-width: 768px) {
    flex: 0 0 auto;
    min-width: 100px;
  }
`;

export const StepActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
  
  @media (max-width: 600px) {
    flex-wrap: wrap;
    gap: 1.5rem;
    
    & > div:first-child {
      width: 100%;
      justify-content: center;
    }
    & > div:last-child {
      width: 100%;
      justify-content: space-between;
    }
  }
`;
